function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.213 2.02A2.016 2.016 0 002.197.006 2.016 2.016 0 00.121 2.021c0 .84-.006 1.238-.001 1.636.011.861.074 1.722.364 7.07a1.683 1.683 0 103.366 0c.292-5.448.354-6.3.364-7.154.004-.381-.001-.762-.001-1.552zM0 15.795a2.207 2.207 0 104.414.006A2.207 2.207 0 000 15.794z",
  fill: "#fff"
});

var SvgExclamation = function SvgExclamation(props) {
  return React.createElement("svg", _extends({
    width: 5,
    height: 19,
    viewBox: "0 0 5 19",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='5' height='19' viewBox='0 0 5 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.21252 2.02063C4.21252 0.90746 3.31012 0.00505874 2.19695 0.00505874C1.65199 -0.0112975 1.12365 0.193814 0.732474 0.573594C0.3413 0.953374 0.120666 1.47542 0.120911 2.02063C0.120911 2.86134 0.114874 3.25929 0.119969 3.65709C0.130998 4.51821 0.194193 5.37865 0.483714 10.7279C0.483714 11.6574 1.23722 12.4109 2.16672 12.4109C3.09621 12.4109 3.84972 11.6574 3.84972 10.7279C4.14236 5.27909 4.20377 4.42617 4.2138 3.57265C4.21828 3.19168 4.21252 2.81059 4.21252 2.02063ZM2.62385e-06 15.7937C-0.00185291 17.01 0.980671 17.9985 2.19695 18.0041C2.78579 18.0068 3.35129 17.7741 3.76767 17.3577C4.18405 16.9413 4.41677 16.3758 4.41408 15.787C4.40851 14.5707 3.41997 13.5882 2.20368 13.59C0.987393 13.5919 0.00185816 14.5774 2.62385e-06 15.7937Z' fill='white'/%3E %3C/svg%3E";
export { SvgExclamation as ReactComponent };